import React, { useEffect, useState } from 'react';
import { CrmButton, CrmDrawer, CrmInput, CrmSelect } from '../ui';
import { useSettings } from '../../context/SettingsContext';
import CrmDateFilterInput from './CrmDateFilterInput';

function FilterEditor({ definition, value, onChange, dateFormat }) {
  if (definition.type === 'date-range') {
    return (
      <div className="crm-advanced-filter__date-fields">
        <CrmDateFilterInput
          value={value?.startDate || ''}
          dateFormat={dateFormat}
          onChange={(startDate) => onChange({ ...value, startDate })}
          ariaLabel={`${definition.label} from`}
        />
        <span>to</span>
        <CrmDateFilterInput
          value={value?.endDate || ''}
          dateFormat={dateFormat}
          onChange={(endDate) => onChange({ ...value, endDate })}
          ariaLabel={`${definition.label} to`}
        />
      </div>
    );
  }

  if (definition.type === 'select') {
    return (
      <CrmSelect
        value={value?.value || ''}
        onChange={(event) => onChange({ value: event.target.value })}
        aria-label={definition.label}
      >
        <option value="">Any</option>
        {definition.options?.map((option) => (
          <option key={String(option.value)} value={option.value}>{option.label}</option>
        ))}
      </CrmSelect>
    );
  }

  return (
    <CrmInput
      type="text"
      value={value?.value || ''}
      onChange={(event) => onChange({ value: event.target.value })}
      placeholder={`Filter ${definition.label.toLowerCase()}`}
      aria-label={definition.label}
    />
  );
}

function CrmAdvancedFilters({
  open,
  onClose,
  definitions,
  filters,
  onApply,
  onClear,
  initialFilterId,
}) {
  const { settings } = useSettings();
  const dateFormat = settings?.date_format || 'DD/MM/YYYY';
  const [draft, setDraft] = useState(filters);

  useEffect(() => {
    if (open) setDraft(filters);
  }, [filters, open]);

  useEffect(() => {
    if (!open || !initialFilterId) return undefined;
    const frame = requestAnimationFrame(() => {
      document.querySelector(`[data-crm-filter-id="${initialFilterId}"] input, [data-crm-filter-id="${initialFilterId}"] select`)?.focus();
    });
    return () => cancelAnimationFrame(frame);
  }, [initialFilterId, open]);

  return (
    <CrmDrawer
      open={open}
      onClose={onClose}
      title="Advanced filters"
      subtitle="All active filters are combined."
      size="sm"
      className="crm-advanced-filter"
      footer={(
        <>
          <CrmButton
            variant="tertiary"
            onClick={() => {
              setDraft({});
              onClear();
            }}
          >
            Clear all
          </CrmButton>
          <div className="crm-column-manager__footer-spacer" />
          <CrmButton onClick={onClose}>Cancel</CrmButton>
          <CrmButton
            variant="primary"
            onClick={() => {
              onApply(draft);
              onClose();
            }}
          >
            Apply filters
          </CrmButton>
        </>
      )}
    >
      <div className="crm-advanced-filter__list">
        {definitions.map((definition) => (
          <label key={definition.id} className="crm-advanced-filter__field" data-crm-filter-id={definition.id}>
            <span>{definition.label}</span>
            <FilterEditor
              definition={definition}
              value={draft[definition.id]}
              onChange={(value) => setDraft((previous) => ({ ...previous, [definition.id]: value }))}
              dateFormat={dateFormat}
            />
          </label>
        ))}
      </div>
    </CrmDrawer>
  );
}

export default CrmAdvancedFilters;
